import { Navigate } from 'react-router-dom'

import { useAuthStore } from 'stores/authStore'

const ProtectedRoute = ({ children }) => {
  const { isAuth } = useAuthStore()

  if (!isAuth()) {
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedRoute
